import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import AOS from "aos";

export default function AOSWrapper({ children }) {
  const location = useLocation();

  useEffect(() => {

      AOS.init({
        once: true,
        duration: 1000,
      });
  
    }, [location]);

  return children;
}